export default __webpack_public_path__ + "static/media/user.018972e2.svg";